export const fontSize = px => `${px / 8}rem`;

export const respSize = px => `${px / 8}rem`;
